// src/hooks/useUserData.js
import React, { createContext, useContext, useState, useEffect } from 'react';
import { auth, db } from '../firebase';
import { doc, onSnapshot } from 'firebase/firestore';

const UserDataContext = createContext();

export const UserDataProvider = ({ children }) => {
  const [userData, setUserData] = useState(null);
  const [loadingUserData, setLoadingUserData] = useState(true);

  useEffect(() => {
    let unsubscribeSnapshot = null;
    const unsubscribeAuth = auth.onAuthStateChanged((user) => {
      if (unsubscribeSnapshot) {
        unsubscribeSnapshot();
        unsubscribeSnapshot = null;
      }

      if (user) {
        const userRef = doc(db, 'users', user.uid);
        unsubscribeSnapshot = onSnapshot(
          userRef,
          (snap) => {
            setUserData(snap.exists() ? snap.data() : null);
            setLoadingUserData(false);
          },
          (err) => {
            console.error('Error loading user data:', err);
            setLoadingUserData(false);
          }
        );
      } else {
        setUserData(null);
        setLoadingUserData(false);
      }
    });

    return () => {
      unsubscribeAuth();
      if (unsubscribeSnapshot) unsubscribeSnapshot();
    };
  }, []);

  return (
    <UserDataContext.Provider value={{ userData, loadingUserData }}>
      {children}
    </UserDataContext.Provider>
  );
};

export const useUserData = () => {
  const ctx = useContext(UserDataContext);
  if (ctx === undefined) {
    throw new Error('useUserData must be used within a UserDataProvider');
  }
  return ctx;
};
